export default __webpack_public_path__ + "static/how-to-4516cb7cff221263783f4a39b8a1234a.svg";